import { gql, useMutation } from "@apollo/client";
import {
  RecordUnaccompaniedParticipantMutation,
  RecordUnaccompaniedParticipantMutationVariables,
} from "../generated/graphql";

const recordUnaccompaniedParticipantMutation = gql`
  mutation RecordUnaccompaniedParticipant(
    $entityShortId: String!
    $entityType: UserType!
    $name: String!
  ) {
    recordUnaccompaniedParticipant(
      entityShortId: $entityShortId
      entityType: $entityType
      name: $name
    ) {
      entityShortId
    }
  }
`;

export function useRecordUnaccompaniedParticipantMutation() {
  return useMutation<
    RecordUnaccompaniedParticipantMutation,
    RecordUnaccompaniedParticipantMutationVariables
  >(recordUnaccompaniedParticipantMutation);
}
